import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'ProductCount',
  props: {
    count: {
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  computed: {
    result: function result() {
      return "".concat(this.count, " ").concat(this.$i18n.tc('product', this.count));
    }
  }
};